import React, { useState } from 'react';
import { IoInformationCircle } from "react-icons/io5";
import { TbListDetails } from "react-icons/tb";
import Select from 'react-select';
import Button from 'react-bootstrap/Button';
import { FaPencilAlt } from "react-icons/fa";
import Alert from 'react-bootstrap/Alert';
import { useNavigate } from 'react-router-dom';

export default function AddAnnouncements() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    title: '',
    message: '',
    category: ''
  });

  const [options] = useState([
    { value: '', label: '--Select--' },
    { value: 'All', label: 'All' },
    { value: 'HR', label: 'HR' },
    { value: 'Employee', label: 'Employee' },
    { value: 'Accounts', label: 'Accounts' }
  ]);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertVariant, setAlertVariant] = useState('success');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSelectChange = (selectedOption) => {
    setFormData({
      ...formData,
      category: selectedOption ? selectedOption.value : ''
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Retrieve the role (author) from localStorage
    const author = localStorage.getItem('role'); // Ensure 'role' is stored in localStorage

    if (!author) {
      setAlertMessage('Author role is missing. Please log in again.');
      setAlertVariant('danger');
      setShowAlert(true);
      // Hide alert after 2 seconds even for errors
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
      return;
    }

    try {
      const response = await fetch('http://localhost:5544/api/announcements/add-announcements', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          title: formData.title,
          content: formData.message,
          category: formData.category,
          author, // Include author in the request body
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to add announcement');
      }

      setAlertMessage('Announcement added successfully!');
      setAlertVariant('success');
      setShowAlert(true);

      // Reset form fields after successful submission
      setFormData({
        title: '',
        message: '',
        category: ''
      });

      // Set timeout to navigate after 2 seconds
      setTimeout(() => {
        setShowAlert(false);
        navigate('/emp-announcements');
      }, 2000);
    } catch (error) {
      console.error('Error details:', error);
      setAlertMessage(error.message);
      setAlertVariant('danger');
      setShowAlert(true);
      // Hide alert after 2 seconds
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
    }
  };

  return (
    <div className='container-fluid'>
      <h1 style={{ marginTop: '60px', fontSize: '2rem', color: '#0353a4' }}>
        <IoInformationCircle className="salary-icon" /> Announcements Information
      </h1>
      <hr />
      <h2 className="salary-subtitle">
        <TbListDetails className="salary-icon" /> Announcements Details
      </h2>
      <hr />
      <div className="table-container">
        {/* Fancy Alert Component */}
        {showAlert && (
          <div style={{
            position: 'fixed',
            top: '20px',
            right: '20px',
            minWidth: '300px',
            borderRadius: '10px',
            boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
            overflow: 'hidden',
            zIndex: 1050,
            animation: 'slideIn 0.5s forwards',
            background: alertVariant === 'success' ? 'linear-gradient(135deg, #d4edda, #c3e6cb)' : 'linear-gradient(135deg, #f8d7da, #f5c6cb)',
            borderLeft: alertVariant === 'success' ? '5px solid #28a745' : '5px solid #dc3545',
            color: alertVariant === 'success' ? '#155724' : '#721c24'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              padding: '15px 20px'
            }}>
              <div style={{
                fontSize: '24px',
                marginRight: '15px',
                fontWeight: 'bold'
              }}>
                {alertVariant === 'success' ? '✓' : '⚠'}
              </div>
              <div style={{
                flex: 1,
                fontWeight: '500'
              }}>{alertMessage}</div>
            </div>
            <div style={{
              height: '5px',
              width: '100%',
              background: alertVariant === 'success' ? 'linear-gradient(to right, #28a745, #8fd19e)' : 'linear-gradient(to right, #dc3545, #e6858d)',
              animation: 'progressBar 2s linear forwards'
            }} />
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="title" style={{ fontWeight: 'bold' }}>
              Announcement Title <span style={{ color: 'red' }}> *</span>
            </label>
            <input
              type="text"
              id="title"
              name="title"
              className="form-control"
              value={formData.title}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="message" style={{ fontWeight: 'bold' }}>
              Announcement Message <span style={{ color: 'red' }}> *</span>
            </label>
            <textarea
              id="message"
              name="message"
              className="form-control"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>
          <div className="form-group">
            <label htmlFor="category" style={{ fontWeight: 'bold' }}>
              Announcement For <span style={{ color: 'red' }}> *</span>
            </label>
            <Select
              id="category"
              options={options}
              onChange={handleSelectChange}
              value={options.find(option => option.value === formData.category)}
              isClearable
              placeholder="--Select--"
            />
          </div>
          <div className="py-3">
            <Button variant="primary" type="submit">
              <FaPencilAlt /> Add Announcement
            </Button>
          </div>
        </form>
        
        {/* Add the animation styles */}
        <style>
          {`
            @keyframes slideIn {
              from {
                transform: translateX(100%);
                opacity: 0;
              }
              to {
                transform: translateX(0);
                opacity: 1;
              }
            }
            
            @keyframes progressBar {
              from {
                width: 100%;
              }
              to {
                width: 0%;
              }
            }
          `}
        </style>
      </div>
    </div>
  );
}